import { PERMISSIONS } from '../../constants';
import edit from './AppConfigEdit';
import { APP_CONFIG_RESOURCE } from './tabs';

export default {
  list: edit,
  name: APP_CONFIG_RESOURCE,
  permissions: [PERMISSIONS.SETTINGS],
  options: { label: 'Aplicativo' },
};
